// The three percentages behind every bar on Master Admin → Quiz responses. Pure, so it is tested
// without the chart library.

/** Started / signed up / scored, for one option or one country. */
export type Split = {count: number; converted: number; scored: number};

export type SplitPercents = {
    /** Share of everyone who answered this question that picked this option. */
    clickedOfAnswered: number | null;
    /** Of those who picked it, how many signed up. */
    signedUpOfClicked: number | null;
    /** Of those who signed up, how many went on to enter scores. */
    scoredOfSignedUp: number | null;
    /** Start to finish: of those who picked it, how many entered scores. */
    scoredOfClicked: number | null;
};

const ratio = (n: number, of: number): number | null => (of > 0 ? n / of : null);

/**
 * `answered` is the people who answered the question, not the sum of the option counts — on a
 * multi-select question one person is several clicks, and the shares rightly add to over 100%.
 */
export function splitPercents(row: Split, answered: number): SplitPercents {
    return {
        clickedOfAnswered: ratio(row.count, answered),
        signedUpOfClicked: ratio(row.converted, row.count),
        scoredOfSignedUp:  ratio(row.scored, row.converted),
        scoredOfClicked:   ratio(row.scored, row.count),
    };
}

/** "35%", "<1%" for a real but tiny share, "—" when there is nothing to divide by. */
export function pctLabel(r: number | null): string {
    if (r === null) return '—';
    if (r > 0 && r < 0.005) return '<1%';
    return Math.round(r * 100) + '%';
}

/** The label drawn on a bar: the count, then the percentage that bar stands for. */
export function barLabel(seriesIndex: number, row: Split, answered: number): string {
    const p = splitPercents(row, answered);
    const [value, pct] = seriesIndex === 0
        ? [row.count, p.clickedOfAnswered]
        : seriesIndex === 1 ? [row.converted, p.signedUpOfClicked] : [row.scored, p.scoredOfSignedUp];
    if (value <= 0) return '';
    return pct === null ? String(value) : `${value} · ${pctLabel(pct)}`;
}
